// extracted by mini-css-extract-plugin
module.exports = {"faqMenuCard":"page_faqMenuCard__NI8A4","faqContent":"page_faqContent__8UFpW","faqCalloutCard":"page_faqCalloutCard__IFTuZ"};